/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewInstagram_viewer = {
    readonly tradePortfolioInstagram: boolean | null;
    readonly " $refType": "OverviewInstagram_viewer";
};
export type OverviewInstagram_viewer$data = OverviewInstagram_viewer;
export type OverviewInstagram_viewer$key = {
    readonly " $data"?: OverviewInstagram_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewInstagram_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "OverviewInstagram_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "tradePortfolioInstagram",
      "name": "featureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "tradePortfolioInstagram"
        }
      ],
      "storageKey": "featureFlag(feature:\"tradePortfolioInstagram\")"
    }
  ]
};
(node as any).hash = 'bb47bd6acf94096d35894a7a39f102d3';
export default node;
